import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatDate } from '../../hooks/useAdminData';

const STATUS_OPTIONS = ['new', 'reviewed', 'contacted', 'completed'];

export const IntakeDetailView = ({ intake, onBack, onUpdateStatus }) => {
  const handleStatusChange = (e) => {
    onUpdateStatus('intake', intake.id, e.target.value);
  };

  return (
    <div data-testid="admin-intake-detail">
      <Button variant="ghost" onClick={onBack} className="mb-4 text-darkBrown">
        <ArrowLeft size={16} className="mr-1" /> Back to List
      </Button>
      <Card className="border-none shadow-xl">
        <CardHeader className="bg-primaryOrange text-white rounded-t-lg">
          <div className="flex justify-between items-center">
            <CardTitle className="text-white">{intake.firstName} {intake.lastName}</CardTitle>
            <select
              value={intake.status}
              onChange={handleStatusChange}
              className="text-sm border rounded-md px-3 py-1.5 text-darkBrown bg-white"
            >
              {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </CardHeader>
        <CardContent className="p-6 space-y-6">
          <Section title="Basic Information">
            <Row label="Name" value={`${intake.firstName} ${intake.lastName}`} />
            <Row label="Date of Birth" value={intake.dateOfBirth} />
            <Row label="Gender" value={intake.gender} />
            <Row label="Address" value={`${intake.address} ${intake.city}, ${intake.state} ${intake.zipCode}`.trim()} />
            <Row label="Phone" value={intake.phone} />
            <Row label="Email" value={intake.email} />
            <Row label="Emergency Contact" value={`${intake.emergencyContact?.name || 'N/A'} (${intake.emergencyContact?.relationship || 'N/A'}) - ${intake.emergencyContact?.phone || 'N/A'}`} />
          </Section>
          <Section title="Insurance">
            <Row label="Provider" value={intake.insuranceProvider || 'Self-pay'} />
            <Row label="Policy #" value={intake.policyNumber} />
            <Row label="Group #" value={intake.groupNumber} />
            <Row label="Subscriber" value={intake.subscriberName} />
          </Section>
          <Section title="Medical History">
            <Row label="Medications" value={intake.currentMedications} />
            <Row label="Allergies" value={intake.allergies} />
            <Row label="Past Diagnoses" value={intake.pastDiagnoses} />
            <Row label="Current Physician" value={intake.currentPhysician} />
          </Section>
          <Section title="Mental Health History">
            <Row label="Reason for Visit" value={intake.reasonForVisit} />
            <Row label="Current Symptoms" value={intake.currentSymptoms} />
            <Row label="Previous Treatments" value={intake.previousTreatments} />
            <Row label="Substance Use" value={intake.substanceUse} />
          </Section>
          <Section title="Family History">
            <Row label="Family Mental Health" value={intake.familyMentalHealthHistory} />
          </Section>
          <Section title="Consent">
            <Row label="HIPAA Consent" value={intake.hipaaConsent ? 'Agreed' : 'Not agreed'} />
            <Row label="Signature" value={intake.consentSignature} />
          </Section>
          <p className="text-xs text-gray-400 text-right">Submitted: {formatDate(intake.timestamp)}</p>
        </CardContent>
      </Card>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h3 className="text-lg font-bold text-primaryOrange border-b-2 border-primaryOrange/30 pb-2 mb-3">{title}</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">{children}</div>
  </div>
);

const Row = ({ label, value }) => (
  <div className="py-1.5">
    <span className="text-sm font-medium text-gray-500">{label}:</span>
    <span className="text-sm text-darkBrown ml-2">{value || 'N/A'}</span>
  </div>
);
